export default {
  top_projects: "TOP projects".toUpperCase(),
  show_more: "show more".toUpperCase(),
};
